import React, { useEffect, useState } from "react";
import { ImageIcon } from "lucide-react";
import { api } from "../../lib/api";
import { BACKEND } from "../../lib/portfolio";

export function SignedMedia({ media, variant = "thumb", className = "", alt, video = false, testId }) {
  const [src, setSrc] = useState(null);
  const [poster, setPoster] = useState(null);
  const ready = media.processing_state === "ready" && media.variants?.includes(variant);
  useEffect(() => {
    let live = true;
    if (!ready) { setSrc(null); return undefined; }
    api.get(`/admin/portfolio/media/${media.id}/signed-url`, { params: { variant } })
      .then((r) => live && setSrc(`${BACKEND}${r.data.url}`)).catch(() => {});
    if (video && media.variants?.includes("poster")) {
      api.get(`/admin/portfolio/media/${media.id}/signed-url`, { params: { variant: "poster" } })
        .then((r) => live && setPoster(`${BACKEND}${r.data.url}`)).catch(() => {});
    }
    return () => { live = false; };
  }, [media.id, variant, ready, video, media.variants]);

  const label = alt || media.alt_text || media.caption || `${media.kind} preview`;
  if (!src) {
    return (
      <div className={`flex items-center justify-center bg-erf-creamSecondary text-erf-dark/50 ${className}`}
        role="img" aria-label={`${label} (not ready)`} data-testid={testId}>
        <ImageIcon className="w-6 h-6" aria-hidden="true" />
      </div>
    );
  }
  if (video) {
    return <video src={src} poster={poster || undefined} controls preload="metadata" className={className}
      aria-label={label} data-testid={testId} />;
  }
  return <img src={src} alt={label} className={`object-cover ${className}`} loading="lazy" data-testid={testId} />;
}
